import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = { class: "filters" }
const _hoisted_3 = { class: "filters-section" }
const _hoisted_4 = { class: "filter-item" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", null, " Name: ", -1)
const _hoisted_6 = { class: "filter-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", null, " Status: ", -1)
const _hoisted_8 = { class: "filters-section" }
const _hoisted_9 = { class: "filter-item" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h5", null, " Date Received: ", -1)
const _hoisted_11 = { class: "striped small toggle equal-widths claims no-underline" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["colspan"]
const _hoisted_14 = { class: "table-row_wrapper d-flex flex-column gap-20" }
const _hoisted_15 = { class: "d-flex justify-content-between flex-wrap flex-md-nowrap gap-20" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "toggle-cell view-details" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "cell-header hide-desktop" }, [
  /*#__PURE__*/_createTextVNode(" Date(s) "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" of Services ")
], -1)
const _hoisted_19 = { class: "cell-text text-wrap" }
const _hoisted_20 = { class: "cell d-flex gap-10" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "cell-header hide-desktop" }, " Claim #", -1)
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "cell d-flex gap-10" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "cell-header hide-desktop" }, " Web Referennce #", -1)
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "cell d-flex gap-10" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "cell-header hide-desktop" }, " Patient Name", -1)
const _hoisted_28 = { class: "cell-text text-wrap" }
const _hoisted_29 = { class: "cell d-flex gap-10" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "cell-header hide-desktop" }, " Patient DOB", -1)
const _hoisted_31 = { class: "cell-text text-wrap" }
const _hoisted_32 = { class: "cell d-flex gap-10" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "cell-header hide-desktop" }, " Relationship", -1)
const _hoisted_34 = { class: "cell-text text-wrap" }
const _hoisted_35 = { class: "cell d-flex gap-10" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", { class: "cell-header hide-desktop" }, " Claim Status", -1)
const _hoisted_37 = { class: "cell-text text-wrap" }
const _hoisted_38 = { class: "cell d-flex gap-10" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", { class: "cell-header hide-desktop" }, " Claim Doc(s)", -1)
const _hoisted_40 = ["onClick", "src"]
const _hoisted_41 = { class: "cell d-flex gap-10" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", { class: "cell-header hide-desktop" }, " EoB Doc(s)", -1)
const _hoisted_43 = ["onClick", "src"]
const _hoisted_44 = {
  key: 1,
  class: "cell-text tex-wrap"
}
const _hoisted_45 = {
  key: 0,
  class: "d-flex subitems-columns flex-column gap-20 p-15 sm-pdl-5 sm-pdr-0 sm-pdt-0"
}
const _hoisted_46 = { class: "d-flex subitems-columns_wrapper w-100" }
const _hoisted_47 = { class: "d-flex flex-column gap-2" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("h5", { class: "text-dark fw-bold sm-fs-xs" }, " Claim Details ", -1)
const _hoisted_49 = { class: "d-flex subitems-columns_details flex-md-nowrap flex-wrap" }
const _hoisted_50 = { class: "d-flex flex-column gap-2" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("p", null, " AmtRequested ", -1)
const _hoisted_52 = { class: "sm-fs-xs" }
const _hoisted_53 = { class: "d-flex flex-column gap-2" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("p", null, " Pd By Other Carrier ", -1)
const _hoisted_55 = { class: "sm-fs-xs" }
const _hoisted_56 = { class: "d-flex flex-column gap-2" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("p", null, " Admin Fee ", -1)
const _hoisted_58 = { class: "sm-fs-xs" }
const _hoisted_59 = { class: "d-flex flex-column gap-2" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("p", null, " Amt Paid ", -1)
const _hoisted_61 = { class: "sm-fs-xs" }
const _hoisted_62 = { class: "d-flex flex-column gap-2" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("p", null, " Reqst Date ", -1)
const _hoisted_64 = { class: "sm-fs-xs" }
const _hoisted_65 = { class: "d-flex flex-column gap-2" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("p", null, " Previous Claim # ", -1)
const _hoisted_67 = { class: "sm-fs-xs" }
const _hoisted_68 = { class: "d-flex flex-column gap-2" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("h5", { class: "text-dark fw-bold sm-fs-xs" }, " Payment Details ", -1)
const _hoisted_70 = { class: "d-flex subitems-columns_details" }
const _hoisted_71 = { class: "d-flex flex-column gap-2" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("p", null, " Payment Info ", -1)
const _hoisted_73 = { class: "sm-fs-xs" }
const _hoisted_74 = { class: "d-flex flex-column gap-2" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("p", null, " Check / Deposit Date", -1)
const _hoisted_76 = { class: "sm-fs-xs" }
const _hoisted_77 = {
  key: 0,
  class: "d-flex flex-column gap-2"
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("h5", { class: "text-dark fw-bold sm-fs-xs" }, " Claim Notes ", -1)
const _hoisted_79 = { class: "d-flex subitems-columns_details" }
const _hoisted_80 = { class: "d-flex flex-column gap-2" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("p", null, " Notes", -1)
const _hoisted_82 = { class: "sm-fs-xs" }
const _hoisted_83 = {
  key: 0,
  class: "divider divider_horizontal"
}
const _hoisted_84 = {
  key: 1,
  class: "d-flex flex-column gap-2 w-100"
}
const _hoisted_85 = /*#__PURE__*/_createElementVNode("h5", { class: "text-dark fw-bold sm-fs-xs" }, " Notes ", -1)
const _hoisted_86 = { class: "sm-fs-xs" }
const _hoisted_87 = { key: 1 }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("tr", { class: "parent-row" }, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "cell text-center",
    colspan: "6"
  }, [
    /*#__PURE__*/_createElementVNode("p", null, "No data available")
  ])
], -1)
const _hoisted_89 = [
  _hoisted_88
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SortComponent = _resolveComponent("SortComponent")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("small", null, _toDisplayString(_ctx.filters?.PatientName?.FullName), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("small", null, _toDisplayString(_ctx.filters?.ClaimStatus), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_SortComponent, {
            type: _ctx.filters.Sorting.ServiceDate.StartDate,
            "onUpdate:type": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.Sorting.ServiceDate.StartDate) = $event)),
            name: "",
            readonly: true
          }, null, 8, ["type"])
        ])
      ])
    ]),
    _createElementVNode("table", _hoisted_11, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history.headers, (header, key) => {
            return (_openBlock(), _createElementBlock("th", { key: key }, _toDisplayString(header.title), 1))
          }), 128))
        ])
      ]),
      (_ctx.claimStore.history?.rows.length)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.claimStore.history.rows, (row, mainKey) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: mainKey,
                class: "parent-row sm-pdl-10 sm-pdr-10"
              }, [
                _createElementVNode("td", {
                  colspan: _ctx.history?.headers?.length
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", {
                        class: "cell d-flex gap-10",
                        onClick: ($event: any) => (_ctx.toggleCell(mainKey))
                      }, [
                        _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.toggleStates[mainKey] ? '-' : '+'), 1),
                        _hoisted_18,
                        _createElementVNode("p", _hoisted_19, _toDisplayString(row.Parent['Date(s) of Service']), 1)
                      ], 8, _hoisted_16),
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createElementVNode("p", {
                          class: _normalizeClass(["cell-text text-wrap", {'plan-modal': Number(row.Parent['Claim Number'])}]),
                          onClick: ($event: any) => (_ctx.editClaim(row.Parent['Claim Number'], 'claim'))
                        }, _toDisplayString(row.Parent['Claim Number']), 11, _hoisted_22)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("p", {
                          class: _normalizeClass(["cell-text text-wrap", {'plan-modal': !Number(row.Parent['Claim Number'])}]),
                          onClick: ($event: any) => (_ctx.editClaim(row.Parent['Web Reference'], 'webclaim'))
                        }, _toDisplayString(row.Parent['Web Reference']), 11, _hoisted_25)
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _createElementVNode("p", _hoisted_28, _toDisplayString(row.Parent['PatientName']), 1)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createElementVNode("p", _hoisted_31, _toDisplayString(row.Parent['PatientDob']), 1)
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _createElementVNode("p", _hoisted_34, _toDisplayString(row.Parent['PatientRelationship']), 1)
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _hoisted_36,
                        _createElementVNode("p", _hoisted_37, _toDisplayString(row.Parent['Claim Status']), 1)
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _hoisted_39,
                        _createElementVNode("img", {
                          class: "plan-modal",
                          onClick: ($event: any) => (_ctx.openModal(row.Parent['Claim Doc(s)'].path, row.Parent['Claim Doc(s)'].name, row.Parent['Claim Doc(s)'].classes, null, row.Parent['Claim Doc(s)'].props)),
                          src: require('@/assets/images/icons/pdf_primary.svg'),
                          alt: "doc icon",
                          width: "18",
                          height: "18"
                        }, null, 8, _hoisted_40)
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _hoisted_42,
                        (Number(row.Parent['EoB Doc']))
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "plan-modal",
                              onClick: ($event: any) => (_ctx.openModal('smartsearch', null, 'modal-success', null, { DocumentID: row.Parent['EoB Doc']})),
                              src: require('@/assets/images/icons/pdf_primary.svg'),
                              alt: "doc icon",
                              width: "18",
                              height: "18"
                            }, null, 8, _hoisted_43))
                          : (_openBlock(), _createElementBlock("p", _hoisted_44, " No EoB Docs"))
                      ])
                    ]),
                    _createVNode(_Transition, { name: "slide-fade" }, {
                      default: _withCtx(() => [
                        (_ctx.toggleStates[mainKey] && row.Children)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(row.Children), (child, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "d-flex subitems-columns_wrapper flex-column",
                                  key: index
                                }, [
                                  _createElementVNode("div", _hoisted_46, [
                                    _createElementVNode("div", _hoisted_47, [
                                      _hoisted_48,
                                      _createElementVNode("div", _hoisted_49, [
                                        _createElementVNode("div", _hoisted_50, [
                                          _hoisted_51,
                                          _createElementVNode("h5", _hoisted_52, _toDisplayString(_ctx.formatCurrency(child.AmtRequested)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_53, [
                                          _hoisted_54,
                                          _createElementVNode("h5", _hoisted_55, _toDisplayString(_ctx.formatCurrency(child.OtherCarrier)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_56, [
                                          _hoisted_57,
                                          _createElementVNode("h5", _hoisted_58, _toDisplayString(_ctx.formatCurrency(child.AdminFee)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_59, [
                                          _hoisted_60,
                                          _createElementVNode("h5", _hoisted_61, _toDisplayString(_ctx.formatCurrency(child.AmtPaid)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_62, [
                                          _hoisted_63,
                                          _createElementVNode("h5", _hoisted_64, _toDisplayString(child.DateReceived), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_65, [
                                          _hoisted_66,
                                          _createElementVNode("h5", _hoisted_67, _toDisplayString(child.PrevClaim), 1)
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", {
                                      class: _normalizeClass(['divider', { 'hide-mobile': index % 2 === 1 }])
                                    }, null, 2),
                                    _createElementVNode("div", _hoisted_68, [
                                      _hoisted_69,
                                      _createElementVNode("div", _hoisted_70, [
                                        _createElementVNode("div", _hoisted_71, [
                                          _hoisted_72,
                                          _createElementVNode("h5", _hoisted_73, _toDisplayString(child.PaymentInfo ?? '-'), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_74, [
                                          _hoisted_75,
                                          _createElementVNode("h5", _hoisted_76, _toDisplayString(child.CheckDepositDate ?? '-'), 1)
                                        ])
                                      ])
                                    ]),
                                    (!child.Notes || child.Notes?.length < 20)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                          _hoisted_78,
                                          _createElementVNode("div", _hoisted_79, [
                                            _createElementVNode("div", _hoisted_80, [
                                              _hoisted_81,
                                              _createElementVNode("h5", _hoisted_82, _toDisplayString(child.Notes ?? '-'), 1)
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (child.Notes?.length >= 20)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_83))
                                    : _createCommentVNode("", true),
                                  (child.Notes?.length >= 20)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                        _hoisted_85,
                                        _createElementVNode("p", _hoisted_86, _toDisplayString(child.Notes ?? '-'), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ], 8, _hoisted_13)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("tbody", _hoisted_87, _hoisted_89))
    ]),
    (_ctx.claimStore.paginator)
      ? (_openBlock(), _createBlock(_component_PaginationComponent, {
          key: 0,
          paginator: _ctx.claimStore.paginator,
          onFetchData: _ctx.onPageChange
        }, null, 8, ["paginator", "onFetchData"]))
      : _createCommentVNode("", true)
  ]))
}